import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = { class: "topbar-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "topbar-logo"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "topbar-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "topbar-username-and-button"
}
const _hoisted_9 = { class: "download-icon" }
const _hoisted_10 = { class: "topbar-username" }

import { inject, ref } from "vue";
import { authService } from "@/auth/authSingleton";
import { computed } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { apiLoggerKey } from "@/types/ServiceKeys";
import  DownloadIcon from './svg/DownloadIcon.vue'
import FileDownloadPopUp from "./FileDownloadPopUp.vue"

import router from "@/router";
import { RoutePaths } from "@/router/RouteDetails";
import { AuthState } from "@/auth/authStates";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const DownloadQueueOpen = ref(false);
const username = computed(() => {
    return authService.getUserName();
});
const route = useRoute();
async function onLogout() {
    const name = onLogout.name.toString();
    const Message = "Logged out.";
    const Class = name;
    inject(apiLoggerKey)?.LogInformation(Message, Class);
    await authService.logout();
    router.push({ path: RoutePaths.Login });
}

const loggedInBool = computed(async () => {
    return await authService.isLoggedIn() != AuthState.NOT_LOGGED_IN
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_unref(route).name == 'Car Purchase')
            ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Car Purchases"))
            : (_unref(route).name !== 'Root')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_unref(route).name), 1))
              : (_openBlock(), _createElementBlock("h1", _hoisted_7, "Please navigate to your desired destination"))
        ]),
        (_unref(loggedInBool))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(DownloadIcon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {DownloadQueueOpen.value = true;})
                })
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(username)), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onLogout())),
                  type: "submit",
                  class: "topbar-button"
                }, " Logout ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(FileDownloadPopUp, {
      modelValue: DownloadQueueOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((DownloadQueueOpen).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})